module.exports = __webpack_public_path__ + "static/media/call.d7ce4c21.png";